import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate, useParams } from "react-router-dom";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useGetDistributorMappingForSkDreamsMutation } from "../../../features/tenant/userMapping/userMappingApi";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";

const DistributorRetailerMapping = () => {
    const { distributorId } = useParams();
    const navigate = useNavigate();

    const [retailerList, setRetailerList] = useState([]);
    const [csvData, setCsvData] = useState(null);
    const [retailerFilters, setRetailerFilters] = useState({
        name: "",
        mobile: ""
    });

    const [distributorInfo, setDistributorInfo] = useState(null);

    const [
        fetchRetailerScans,
        { data: retailerScansData, error: retailerScansError, isLoading: retailerScansIsLoading },
    ] = useGetDistributorMappingForSkDreamsMutation();

    const [
        fetchRetailerCsv,
        { data: retailerCsvData, error: retailerCsvError },
    ] = useGetDistributorMappingForSkDreamsMutation();

    useEffect(() => {
        // Get distributor info from navigation state
        const state = window.history.state?.usr;
        if (state?.distributor) {
            setDistributorInfo(state.distributor);
        }

        // Fetch retailer mappings
        if (distributorId) {
            fetchRetailerMappings(distributorId, "", "");
        }
    }, [distributorId]);

    const fetchRetailerMappings = (distId, name = retailerFilters.name, mobile = retailerFilters.mobile) => {
        fetchRetailerScans({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            id: distId,
            name: name,
            mobile: mobile,
        });
    };

    const handleRetailerSearch = () => {
        fetchRetailerMappings(distributorId, retailerFilters.name, retailerFilters.mobile);
    };

    const handleRetailerClearFilters = () => {
        setRetailerFilters({ name: "", mobile: "" });
        fetchRetailerMappings(distributorId, "", "");
    };

    const fetchRetailerCsvFunction = () => {
        fetchRetailerCsv({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            id: distributorId,
            name: retailerFilters.name,
            mobile: retailerFilters.mobile,
            export: true,
        });
    };

    useEffect(() => {
        if (retailerScansData && retailerScansData.body) {
            setRetailerList(retailerScansData.body.userList || []);
        }
    }, [retailerScansData, retailerScansError]);

    useEffect(() => {
        if (retailerCsvData && retailerCsvData?.body?.userList) {
            setCsvData(retailerCsvData.body.userList);
        }
        if (retailerCsvError) {
            setCsvData(null);
        }
    }, [retailerCsvData, retailerCsvError]);

    const retailerColumns = [
        {
            name: "SNo",
            cell: (row, idx) => Number(idx + 1),
            sortable: true,
        },
        {
            name: "Retailer Name",
            cell: (row) => row.name || "-",
            sortable: true,
        },
        {
            name: "Retailer Mobile",
            cell: (row) => row.mobile || "-",
            sortable: true,
        },
        {
            name: "Retailer Firm Name",
            cell: (row) => row.firm_name || "-",
            sortable: true,
        },
        {
            name: "Scan Count",
            cell: (row) => row.count || 0,
            sortable: true,
        }, {
            name: "Points",
            cell: (row) => row.total_points || 0,
            sortable: true,
        },
    ];

    return (
        <div className="flex w-full bg-gray-200 h-full justify-center">
            <div className="w-full">
                <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                    <div className="flex justify-between items-center pr-6">
                        <div>
                            Retailer Mapping
                            {distributorInfo && (
                                <div className="text-sm font-normal text-gray-600 mt-1">
                                    Distributor: {distributorInfo.name} ({distributorInfo.mobile})
                                </div>
                            )}
                        </div>
                        <button
                            onClick={() => navigate(-1)}
                            className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded text-sm"
                        >
                            ← Back
                        </button>
                    </div>
                    <LinksComponent />
                </div>

                <div className="p-3">
                    <div className="w-full bg-white shadow rounded-lg">
                        {retailerScansIsLoading && <CircleLoaderComponent />}

                        {/* Export Section */}
                        <div className="border-b border-gray-300 bg-white p-3">
                            <div className="flex justify-end">
                                <CustomExport
                                    data={csvData}
                                    fetchData={fetchRetailerCsvFunction}
                                    filename={`retailer_mapping_${distributorInfo?.name || distributorId}`}
                                    defaultColumnExport={['app_user_id', 'name', 'mobile', 'count', 'total_points']}
                                />
                            </div>
                        </div>

                        <DataTableComponent
                            keyField={(row) => row.app_user_id || row.id || row.mobile}
                            columns={retailerColumns}
                            data={retailerList}
                            pagination={false}
                        >
                            <div className="border-b border-gray-300 bg-gray-50 rounded-t-lg p-3">
                                <div className="flex space-x-2 justify-end">
                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Name
                                            </label>
                                            <input
                                                type="search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Retailer name..."
                                                value={retailerFilters.name}
                                                onChange={(e) => {
                                                    setRetailerFilters((prev) => ({
                                                        ...prev,
                                                        name: e.target.value,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Mobile
                                            </label>
                                            <input
                                                type="search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Mobile..."
                                                value={retailerFilters.mobile}
                                                onChange={(e) => {
                                                    setRetailerFilters((prev) => ({
                                                        ...prev,
                                                        mobile: e.target.value,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="flex flex-row gap-2 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right p-2"
                                                onClick={handleRetailerSearch}
                                            >
                                                Search
                                            </button>
                                        </div>
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right p-2"
                                                onClick={handleRetailerClearFilters}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </DataTableComponent>
                        {retailerList.length === 0 && !retailerScansIsLoading && (
                            <div className="text-center py-8 text-gray-500">
                                No retailers found for this distributor
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DistributorRetailerMapping;
